/**
 * OrganizationsRedirect
 */

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Redirect } from 'react-router-dom';

// Selectors
import { selectCurrentOrganizationId } from '../../../../services/currentOrganizationId/selectors';

interface Props {
    organizationId?: string;
}

class OrganizationsRedirect extends React.PureComponent<Props> {
    render() {
        const { organizationId } = this.props;
        if (!organizationId) {
            return <Redirect to="/organizations" />;
        }
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    organizationId: selectCurrentOrganizationId
});

export default connect(mapStateToProps)(OrganizationsRedirect);
